import { render, staticRenderFns } from "./Outfit.vue?vue&type=template&id=479975b5&"
import script from "./Outfit.vue?vue&type=script&lang=js&"
export * from "./Outfit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports